<template>
  <q-toolbar class="q-mx-none">
    <!-- <div>Sale Portal</div> -->
    <q-btn-group outline class="q-ma-xs">
      <q-btn
        size="11px"
        stack
        :label="currentBranch"
        icon="place"
        @click="onChooseBranch"
        :dense="isMobile"
      ></q-btn>
      <q-btn stack size="11px" label="Home" icon="home" @click="onHome" :dense="isMobile">
      </q-btn>
      <q-btn v-if="isAdmin || isSale" stack size="11px" label="Chat" icon="chat" @click="onChat" :dense="isMobile">
      </q-btn>
      <q-btn
        stack
        size="11px"
        label="Cart"
        icon="shopping_cart"
        @click="onCart"
        :dense="isMobile"
      >
      </q-btn>
      <q-btn
        stack
        size="11px"
        label="Checkout"
        icon="payments"
        @click="onCheckout"
        :dense="isMobile"
      >
      </q-btn>
    </q-btn-group>
    <q-space />
    <q-btn v-if="$q.screen < 600" dense round>
      <q-avatar size="md" color="white" text-color="primary">{{
        firstLetter
      }}</q-avatar>
      <q-menu>
        <q-item clickable>
          <q-item-section no-wrap @click="onOrderHistory"
            >Order History</q-item-section
          >
          <q-item-section no-wrap @click="onSignOut">Sign Out</q-item-section>
        </q-item>
      </q-menu>
    </q-btn>
    <q-btn
      v-else
      dense
      round
      @mouseover="menu.btn = true"
      @mouseleave="menu.btn = false"
    >
      <q-avatar size="md" color="white" text-color="primary">{{
        firstLetter
      }}</q-avatar>
      <q-menu
        v-model="menu.show"
        auto-close
        @mouseover="menu.list = true"
        @mouseleave="menu.list = false"
      >
        <q-item clickable v-if="isAdmin">
          <q-item-section no-wrap @click="onAdmin">Admin</q-item-section>
        </q-item>
        <q-item clickable v-if="isAdmin">
          <q-item-section no-wrap @click="onStat">Branch data</q-item-section>
        </q-item>
        <q-item clickable v-if="isAdmin">
          <q-item-section no-wrap @click="onSaleStat">Sale data</q-item-section>
        </q-item>
        <!-- <q-item clickable v-if="isAdmin">
          <q-item-section no-wrap @click="onChatDashboard"
            >Chat dashboard</q-item-section
          >
        </q-item> -->
        <q-item clickable v-if="isAdmin">
          <q-item-section no-wrap @click="onCustomerStat"
            >Customer data</q-item-section
          >
        </q-item>
        <q-item clickable v-if="isAdmin">
          <q-item-section no-wrap @click="onSalesByCustomerStat"
            >Sales by Customer</q-item-section
          >
        </q-item>
        <q-item clickable>
          <q-item-section no-wrap @click="onProfile">Profile</q-item-section>
        </q-item>
        <q-item clickable>
          <q-item-section no-wrap @click="onOrderHistory"
            >Order History</q-item-section
          >
        </q-item>
        <q-item clickable>
          <q-item-section no-wrap @click="onSignOut">Sign Out</q-item-section>
        </q-item>
      </q-menu>
    </q-btn>
    <!-- <q-btn no-caps flat @click="onSignOut">Sign out</q-btn> -->
    <q-dialog
      v-model="chooseBranchDialog.show"
      persistent
      :maximized="true"
      transition-show="slide-up"
      transition-hide="slide-down"
    >
      <FullScreenDialog>
        <choose-branch-dialog @choosed-branch="onChooseBranch" />
      </FullScreenDialog>
    </q-dialog>
  </q-toolbar>
</template>

<script>
import Auth from "@aws-amplify/auth";
import useAuth from "@/mixins/useAuth";
import { debounce } from "quasar";
import { QDialog } from "quasar";

const components = { QDialog };

export default {
  name: "ToolBar",
  components: {
    ...components,
    FullScreenDialog: () => import("@/ui/components/FullScreenDialog.vue"),
    ChooseBranchDialog: () => import("@/ui/components/ChooseBranchDialog.vue"),
  },
  mixins: [useAuth],
  data() {
    return {
      isAdmin: false,
      isSale: false,
      menu: {
        show: false,
        list: false,
        btn: false,
      },
      chooseBranchDialog: {
        show: false,
      },
    };
  },
  computed: {
    currentBranch() {
      return this.$store.state["branch"]["branch"].name;
    },
    isMobile() {
      return this.$q.screen.width < 640;
    },
    firstLetter(){
      return (this.$store.getters["sale/name"] ?? "-")[0]
    }
  },
  watch: {
    "menu.list": {
      immediate: false,
      handler(val) {
        this.debounceFunc();
      },
    },
    "menu.btn": {
      immediate: false,
      handler(val) {
        this.debounceFunc();
      },
    },
  },
  async mounted() {
    const user = await Auth.currentAuthenticatedUser();
    if (user) {
      const session = await Auth.currentSession();
      const groups = session.getIdToken().payload["cognito:groups"];
      console.log({ groups });
      if (groups.includes("Admin")) {
        this.isAdmin = true;
        // console.log("admin check: ", this.isAdmin);
        return;
      }
      if (groups.includes("Sale")) {
        this.isSale = true;
        // console.log("admin check: ", this.isAdmin);
        return;
      }
      this.isAdmin = false;
    }
  },
  methods: {
    debounceFunc: debounce(function () {
      this.checkMenu();
    }, 300),
    checkMenu() {
      console.log("checkMenu");
      if (this.menu.list || this.menu.btn) {
        this.menu.show = true;
      } else {
        this.menu.show = false;
      }
    },
    async onSignOut() {
      console.log("onSignOut");
      await Auth.signOut();
      this.$router.replace("/auth", (err) => {
        console.log(err, "ignored");
      });
    },
    onCart() {
      this.$router.push({
        name: "Cart",
      });
    },
    onCheckout() {
      this.$router.push({
        name: "Checkout",
      });
    },
    onHome() {
      this.$router.push({
        name: "Home",
      });
    },
    onChat() {
      this.$router.push({
        name: "SaleChat",
      });
    },
    onChooseBranch() {
      console.log("onChangeBranch");
      this.chooseBranchDialog.show = !this.chooseBranchDialog.show;
    },
    onOrderHistory() {
      console.log("onOrderHistory");
      this.$router.push({
        name: "OrderHistory",
      });
    },
    onProfile() {
      console.log("onProfile");
      this.$router.push({
        name: "Profile",
      });
    },
    onAdmin() {
      console.log("onAdmin");
      this.$router.push({
        name: "Admin",
      });
    },
    onStat() {
      console.log("onStat");
      this.$router.push({
        name: "AdminStat",
      });
    },
    onSaleStat() {
      console.log("onSaleStat");
      this.$router.push({
        name: "AllSaleStat",
      });
    },
    onCustomerStat() {
      this.$router.push({
        name: "CustomerStat",
      });
    },
    onSalesByCustomerStat() {
      this.$router.push({
        name: "SalesByCustomerStat",
      });
    },
    onChatDashboard() {
      this.$router.push({
        name: "SaleChatDashboard",
      });
    },
  },
};
</script>
